module.exports = require("@splunk/visualization-schemas");